const BANNER_SELECTOR = '[data-verify-email-banner]';

const check = async marker => {
    if ((await (await fetch(marker.dataset.verifyEmailBanner)).json()).verified) {
        marker.closest('.banner').remove();
    }
};

document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
        return;
    }

    document.querySelectorAll(BANNER_SELECTOR).forEach(marker => check(marker));
});
